import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _findInstanceProperty from "@babel/runtime-corejs3/core-js/instance/find";
import _parseFloat from "@babel/runtime-corejs3/core-js/parse-float";
import _spliceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/splice";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import OtherProperties from "./other-properties.vue";
import ConfirmationModalTemplate from "@Shared/@HandlebarsTemplates/modals/_confirmation-modal.hbs";
import * as FieldComponents from "@Shared/components/sections/index";
import DuplicatorMixin from "@Shared/utils/application-mixins/duplicator-mixin";
import ApplicantMixin from "@Broker/@Modules/clients/applications/application/select-options/applicant-mixin";
import VisibilityToggleMixin from "@Shared/utils/application-mixins/visibility-toggle-mixin";
import { createHelpers } from "@joandvgv/vuex-map-fields";
import { mapActions, mapGetters, mapMutations } from "vuex";
import { ADD_APPLICATION_GROUP, REMOVE_APPLICATION_GROUP, REPLICATE_APPLICATION_GROUP, SHOW_FULL_SIN } from "../../../store/application-actions";
import { getFullNameWithSalutationFrom, removeEmptyKeys } from "@Shared/utils/utils";
import { REMOVE_APPLICATION_PAGE_DATA, SET_APPLICATION_WITH_DEFAULTS_FOR_PAGE, SWITCH_PREVIOUS_ADDRESS_TO_CURRENT, UPDATE_EMPLOYMENT_ORDER } from "../../../store/application-mutations";
import ResizeSensor from "@Shared/utils/resize-sensor";
import InlinePrompt from "@Shared/components/general/inline-prompt";
import { BaseModal } from "@Shared/utils/modals";
import ApplicationCardHeader from "@Broker/@Modules/util-components/application-card-header";
import SwapApplicantsDropdown from "./util-components/swap-applicants-dropdown.vue";
import { cloneDeep, debounce, get, isEmpty, kebabCase, mapValues, startCase, toLower } from "lodash";
import AutocompleteSection from "@Shared/components/sections/autocomplete-section.vue";
import { PagesVisibilityMap } from "@Broker/@Utils/application/pages-visibility-map.ts";
import MultipleVisibilityButton from "@Broker/@Modules/clients/applications/application/components/pages-components/application/util-components/multiple-visibility-button.vue";
import { useI18n } from "vue-i18n-composable";
import { GenericModal } from "@Shared/components/modals";
import SimpleButton from "@Shared/components/buttons/simple-button.vue";
const {
  mapFields,
  mapMultiRowFields
} = createHelpers({
  getterType: "getDetails",
  mutationType: "setDetails"
});
import { defineComponent } from "@vue/composition-api";
import { GET_REFERRAL_API_PARTNERS } from "@Broker/@Modules/main/store/account/account-getters";
export default defineComponent({
  name: "Applicant",
  components: _objectSpread(_objectSpread({}, FieldComponents), {}, {
    ResizeSensor,
    InlinePrompt,
    ApplicationCardHeader,
    SwapApplicantsDropdown,
    AutocompleteSection,
    OtherProperties,
    MultipleVisibilityButton,
    GenericModal,
    SimpleButton
  }),
  mixins: [DuplicatorMixin, VisibilityToggleMixin, ApplicantMixin],
  model: {
    prop: "value",
    event: "change"
  },
  props: {
    type: {
      type: String,
      default: ""
    },
    currentApplication: {
      type: Object,
      default: () => ({})
    },
    typeTitle: {
      type: String,
      default: ""
    },
    coAppsPage: {
      type: Boolean,
      default: false
    },
    replicateAddress: {
      type: Boolean,
      default: false
    },
    applicantIndex: {
      type: Number,
      default: 0
    },
    clientUsername: {
      type: null,
      default: ""
    },
    agentUsername: {
      type: null,
      default: null
    },
    applicationId: {
      type: null,
      default: null
    },
    editVisibility: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      liabilityPaymentPercentParser: {
        "credit-card": 0.03,
        "unsecured-line-of-credit": 0.03,
        "secured-line-of-credit": 0.0125
      },
      loadingSIN: false,
      animateAddress: false,
      forceUpdate: 0,
      languageValue: "",
      PagesVisibilityMap,
      showUncommonPeriodConfirmationModal: false,
      selectedIncomePeriod: "",
      previousIncomePeriod: [],
      cancelIncomePeriod: () => {}
    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, mapGetters("AccountStore", [GET_REFERRAL_API_PARTNERS])), {}, {
    isMainApplicantScreen() {
      return this.applicantIndex === 0 || this.applicantIndex === 1;
    },
    isTypeCoApplicant() {
      var _context;
      return _includesInstanceProperty(_context = this.$props.type).call(_context, "co-applicants");
    },
    typeName() {
      return kebabCase(this.typeTitle);
    },
    dataByType() {
      return get(this.currentApplication, this.type);
    },
    fullNameWithSalutation() {
      const {
        "personal-details": personalDetails
      } = get(this.currentApplication, this.type);
      return getFullNameWithSalutationFrom(personalDetails);
    },
    identifier() {
      return this.isTypeCoApplicant || this.coAppsPage ? `co-applicants[${this.applicantIndex - 1}]` : "main-applicant";
    },
    paths() {
      const root = this.type;
      const personalDetails = `${root}[personal-details]`;
      return {
        salutation: personalDetails,
        firstName: personalDetails,
        lastName: personalDetails,
        middleName: personalDetails,
        email: personalDetails,
        phoneNumber: personalDetails,
        workPhone: personalDetails,
        altPhoneNumber: personalDetails,
        firstTimeHomeBuyer: personalDetails,
        dateOfBirth: personalDetails,
        maritalStatus: personalDetails,
        coApplicantType: personalDetails,
        relationshipToMainApplicant: personalDetails,
        sin: personalDetails,
        languagePreference: personalDetails,
        numChildren: personalDetails,
        own: personalDetails,
        monthlyRent: personalDetails,
        coapp: "main-applicant[personal-details]",
        identifications: root,
        risklevel: personalDetails,
        employment: root,
        otherIncome: root,
        liabilities: root,
        assets: root,
        addresses: personalDetails
      };
    },
    visibilityPaths() {
      return mapValues(this.paths, (path, key) => `${path}[${kebabCase(key)}]`);
    }
  }, mapFields("ApplicationStore", {
    salutation() {
      return this.paths.salutation;
    },
    firstName() {
      return this.paths.firstName;
    },
    lastName() {
      return this.paths.lastName;
    },
    middleName() {
      return this.paths.middleName;
    },
    email() {
      return this.paths.email;
    },
    phoneNumber() {
      return this.paths.phoneNumber;
    },
    coapp() {
      return this.paths.coapp;
    },
    workPhone() {
      return this.paths.workPhone;
    },
    altPhoneNumber() {
      return this.paths.altPhoneNumber;
    },
    firstTimeHomeBuyer() {
      return this.paths.firstTimeHomeBuyer;
    },
    dateOfBirth() {
      return this.paths.dateOfBirth;
    },
    maritalStatus() {
      return this.paths.maritalStatus;
    },
    coApplicantType() {
      return this.paths.coApplicantType;
    },
    relationshipToMainApplicant() {
      return this.paths.relationshipToMainApplicant;
    },
    sin() {
      return this.paths.sin;
    },
    languagePreference() {
      return this.paths.languagePreference;
    },
    numChildren() {
      return this.paths.numChildren;
    },
    own() {
      return this.paths.own;
    },
    monthlyRent() {
      return this.paths.monthlyRent;
    },
    risklevel() {
      return this.paths.risklevel;
    }
  })), {}, {
    fintracRiskLevelData() {
      const {
        t
      } = useI18n();
      return [{
        value: "H",
        label: t("application-form.highrisk")
      }, {
        value: "M",
        label: t("application-form.mediumrisk")
      }, {
        value: "L",
        label: t("application-form.lowrisk")
      }];
    }
  }, mapMultiRowFields("ApplicationStore", {
    identifications() {
      return this.paths.identifications;
    },
    employment() {
      return this.paths.employment;
    },
    otherIncome() {
      return this.paths.otherIncome;
    },
    liabilities() {
      return this.paths.liabilities;
    },
    assets() {
      return this.paths.assets;
    },
    addresses() {
      return this.paths.addresses;
    }
  })), {}, {
    hasCoApplicant() {
      const hasCoApplicant = this.coapp === true || this.coapp == null || this.coapp === "true";
      return hasCoApplicant;
    },
    hasReferralPartners() {
      const referralApiPartners = this.GET_REFERRAL_API_PARTNERS;
      return !isEmpty(referralApiPartners);
    },
    allowDeleteFirstCoapp() {
      return this.currentApplication["co-applicants"].length > 1;
    },
    isMultiGroup() {
      const {
        editVisibility,
        hasCoApplicant,
        isTypeCoApplicant
      } = this;
      if (editVisibility || !hasCoApplicant && isTypeCoApplicant) {
        return false;
      }
      return true;
    },
    applicantType() {
      return this.isTypeCoApplicant ? "co-applicants" : "main-applicant";
    },
    atLeastOneRentLiability() {
      if (isEmpty(this.liabilities)) return false;
      return this.liabilities.some(liability => liability.type === "rent");
    },
    filteredLiabilityTypeOptions() {
      var _context2;
      if (this.atLeastOneRentLiability) return this.liabilityTypeOptions;
      return _filterInstanceProperty(_context2 = this.liabilityTypeOptions).call(_context2, liabilityTypeOption => liabilityTypeOption.value !== "rent");
    }
  }),
  watch: {
    risklevel(value) {
      if (value == "H") this.$refs.highRiskTransactionModal.show();
    },
    hasCoApplicant: debounce(function (value) {
      const cleanedData = removeEmptyKeys({
        applicant: this.currentApplication["co-applicants"]
      });
      if (!value && !isEmpty(cleanedData)) {
        this.confirmRemoval();
      }
      if (value) {
        this.SET_APPLICATION_WITH_DEFAULTS_FOR_PAGE({
          page: "co-applicants"
        });
      }
    }, 100)
  },
  methods: _objectSpread(_objectSpread(_objectSpread(_objectSpread({
    handleIncomePeriodClick(value, job) {
      this.previousIncomePeriod.push(job["income-period"]);
    },
    async copyEmail() {
      if (!this.email) {
        return;
      }
      await navigator.clipboard.writeText(this.email);
    },
    handleIncomePeriodChange(newValue, job) {
      if (newValue !== "annual") {
        var _context3;
        this.selectedIncomePeriod = _findInstanceProperty(_context3 = this.incomePeriodOptions).call(_context3, option => option.value === newValue).label;
        this.cancelIncomePeriod = () => {
          setTimeout(() => {
            job["income-period"] = this.previousIncomePeriod[0];
            this.showUncommonPeriodConfirmationModal = false;
            this.$emit("save");
            this.previousIncomePeriod = [];
          }, 0);
        };
        this.showUncommonPeriodConfirmationModal = true;
      } else {
        this.previousIncomePeriod = [];
      }
    }
  }, mapMutations("ApplicationStore", [SET_APPLICATION_WITH_DEFAULTS_FOR_PAGE, SWITCH_PREVIOUS_ADDRESS_TO_CURRENT, UPDATE_EMPLOYMENT_ORDER])), mapActions("ApplicationStore", [ADD_APPLICATION_GROUP, REMOVE_APPLICATION_GROUP, REPLICATE_APPLICATION_GROUP, SHOW_FULL_SIN])), {}, {
    async confirmRemoval() {
      const modalData = {
        title: this.$t("application.actions.disableCoApplicants"),
        name: "co-app-delete",
        message: this.$t("application.messages.thisWillRemoveAllCoApplicants"),
        confirmButtonText: this.$t("global.messages.yesRemoveAll"),
        dismissButtonText: this.$t("global.words.cancel"),
        yes: this.$t("global.words.yes"),
        no: this.$t("global.words.no"),
        doingSoWill: this.$t("boards.messages.removeCollaboratorConfirmation.doingSoWill")
      };
      const confirmationModal = new BaseModal(modalData, ConfirmationModalTemplate, "body");
      const result = await confirmationModal.prompt();
      if (result) {
        await this.REMOVE_APPLICATION_PAGE_DATA({
          page: "co-applicants"
        });
        this.$emit("save");
      } else {
        this.coapp = true;
      }
    },
    onHide(event) {
      if (event.trigger == "backdrop" || event.trigger == "esc" || event.trigger == "headerclose") this.forceUpdate += 1;
    },
    handleLanguageChange(value) {
      this.languageValue = value;
      if (value !== "" && !this.isTypeCoApplicant) this.$refs["changeLanguageModal"].show();else {
        this.languagePreference = value;
        this.$emit("save");
      }
    },
    handleOk() {
      this.languagePreference = this.languageValue;
      this.$emit("save");
    },
    handleCancel() {
      this.forceUpdate += 1;
    }
  }, mapMutations("ApplicationStore", [REMOVE_APPLICATION_PAGE_DATA])), {}, {
    handleVisibility(data) {
      this.$emit("toggle-visibility", data);
    },
    tabIndex(value) {
      return this.isTypeCoApplicant ? value + 1 : value;
    },
    toSentence(val) {
      return startCase(toLower(val));
    },
    log(whatever) {
      //eslint-disable-next-line no-console
      console.log(whatever);
    },
    addressTitle(index) {
      if (this.editVisibility) return "";
      return index > 0 ? `${this.ordinalIndex(index - 1)} ${this.$t("application-form.previous-address")}` : this.$t("application-form.current-address");
    },
    async showSIN() {
      try {
        this.loadingSIN = true;
        await this.SHOW_FULL_SIN({
          applicantIndex: this.applicantIndex,
          clientUsername: this.clientUsername,
          applicationId: this.applicationId
        });
      } finally {
        this.loadingSIN = false;
      }
    },
    handleDuplicate({
      what,
      where,
      markAsVisible,
      startEmpty,
      amountItems
    }) {
      this.ADD_APPLICATION_GROUP({
        what,
        where,
        markAsVisible,
        startEmpty,
        amountItems
      });
      this.$emit("save");
    },
    handleRemove(index, removePath, ref, startEmpty) {
      this.REMOVE_APPLICATION_GROUP({
        index,
        where: removePath,
        startEmpty
      });
      this.$emit("height-remove", ref);
      this.$emit("save");
    },
    handleRemoveCoapp(index, removePath) {
      this.$refs["delete-coapp-prompt"].open = false;
      this.REMOVE_APPLICATION_GROUP({
        index,
        where: removePath
      });
      this.$emit("save");
    },
    handleResize(path, opts = {}) {
      this.$emit("change-height", path, opts);
    },
    handleHeightRemove(path, opts = {}) {
      this.$emit("height-remove", path, opts);
    },
    handleReplicateAddress() {
      this.REPLICATE_APPLICATION_GROUP({
        path: "main-applicant[personal-details][addresses]",
        index: 0,
        targetPath: `${this.type}[personal-details][addresses]`,
        targetIndex: 0
      });
      this.$emit("replicate");
    },
    addAdditionalCoapp() {
      const what = this.getStructure(this.currentApplication["co-applicants"][0]);
      const where = "['co-applicants']";
      this.ADD_APPLICATION_GROUP({
        what,
        where
      });
      this.$emit("page-change", "co-applicants");
    },
    calculateLiabilityPayment(liabilityIndex) {
      const selectedLiability = this.liabilities[liabilityIndex];
      const {
        balance,
        type
      } = selectedLiability;
      const paymentPercentage = this.liabilityPaymentPercentParser[type];
      if (paymentPercentage) {
        const newPaymentValue = _parseFloat(balance) * paymentPercentage;
        this.$nextTick(() => {
          this.liabilities[liabilityIndex].payment = newPaymentValue && newPaymentValue.toString();
        });
      }
    },
    disabledLiability(index) {
      return !!this.liabilityPaymentPercentParser[this.liabilities[index].type];
    },
    handleSave() {
      this.$emit("save");
    },
    handleDisableCoapp(hasCoapp) {
      this.coapp = hasCoapp;
      if (hasCoapp) {
        this.handleSave();
      }
    },
    handleChangeWorkPhone(job, $event) {
      job["work-phone"] = $event;
      this.handleSave();
    },
    async handleChangeAddressToCurrent(index) {
      this.animateAddress = true;
      this.SWITCH_PREVIOUS_ADDRESS_TO_CURRENT({
        index,
        path: this.type
      });
      await this.$nextTick();
      this.animateAddress = false;
      this.handleResize("addresses");
      this.$emit("save");
    },
    handlePageChange(page, opts) {
      this.$emit("page-change", page, opts);
    },
    handleReorderEmployment(oldIndex, newIndex) {
      const applicant = get(this.currentApplication, this.type);
      const employment = cloneDeep(applicant["employment"]);
      const element = _spliceInstanceProperty(employment).call(employment, oldIndex, 1)[0];
      _spliceInstanceProperty(employment).call(employment, newIndex, 0, element);
      this.UPDATE_EMPLOYMENT_ORDER({
        employment,
        path: this.type
      });
      this.handleResize("employment-details");
      this.handleSave();
    },
    handleOpenLifeInsuranceModal() {
      this.$emit("open-life-insurance-modal");
    }
  })
});